// Campaign attribution. utm_* / gclid only ever appear on the landing URL, but
// a form is usually submitted several pages later — so the values are stored in
// cookies on entry and read back at submit time. Spark keeps a custom field for
// each of them.
const TRACKING_PARAMS = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_content',
  'utm_term',
  'gclid'
]

// Google Ads attributes a click for 90 days by default; the utm_* values are
// kept for the same window so a lead does not end up split between two visits.
const MAX_AGE = 90 * 24 * 60 * 60

const readCookie = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`))
  return match ? decodeURIComponent(match[1]) : ''
}

export const captureTrackingParams = () => {
  if (typeof window === 'undefined') return

  const query = new URLSearchParams(window.location.search)
  const secure = window.location.protocol === 'https:' ? '; secure' : ''

  for (const name of TRACKING_PARAMS) {
    const value = query.get(name)
    // A later visit without campaign params must not wipe what we already have.
    if (!value) continue
    document.cookie = `${name}=${encodeURIComponent(value)}; max-age=${MAX_AGE}; path=/; samesite=lax${secure}`
  }
}

export const getTrackingParams = () => {
  if (typeof document === 'undefined') return {}

  const params = {}
  for (const name of TRACKING_PARAMS) {
    const value = readCookie(name)
    if (value) params[name] = value
  }
  return params
}
